import React from "react";

import { Visible } from "./visible";
import { TalkWithUsPrompt } from "./template_offering_checkout_common";
import { Container, Row } from "../components";
import { LocalePicker } from "./locale_picker";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Spacer } from "./spacer";
import { Hidden } from "./hidden";
import { Logo } from "./logo";
import { OfferingMessageType } from "./api";
import { LocaleOption } from "./locale_data";
import { useUTMQueryString } from "../hooks";

interface CatalogHeaderProps {
  logo: string;
  homepageURL: string;
  messageableID: string;
  partnerID: string;
  showLanguageSelector?: boolean;
  localeOptions?: LocaleOption[];
  hubspotForm?: React.ReactNode;
}

export function CatalogHeader(props: CatalogHeaderProps) {
  const {
    logo,
    homepageURL,
    messageableID,
    partnerID,
    hubspotForm,
    showLanguageSelector = false,
    localeOptions,
  } = props;
  const { locale, onChangeLocale } = useI18n();

  const utmQuery = useUTMQueryString();
  const homepageURLWithUTMParams = `${homepageURL}${utmQuery}`;

  return (
    <Container paddingHorizontal={16} height={80}>
      <Spacer size={16} />
      <Visible md>
        <Row flex={1} alignItems="center" justifyContent="space-between">
          <Logo homepageURL={homepageURLWithUTMParams} logo={logo} />
          <Row>
            {showLanguageSelector && localeOptions && (
              <Container minWidth={130}>
                <LocalePicker
                  localeOptions={localeOptions}
                  locale={locale}
                  onChangeLocale={onChangeLocale}
                />
              </Container>
            )}
            <Container minWidth={200}>
              <TalkWithUsPrompt
                partnerID={partnerID}
                hubspotForm={hubspotForm}
                messageableID={messageableID}
                messageableType={OfferingMessageType.PartnerCatalog}
              />
            </Container>
          </Row>
        </Row>
      </Visible>
      {/* In mobile-view, offering menus are hidden in header, but displayed in footer ref to CatalogFooterMobile */}
      <Hidden md>
        <Row flex={1} alignItems="center" justifyContent="center">
          <Logo homepageURL={homepageURLWithUTMParams} logo={logo} />
        </Row>
      </Hidden>
    </Container>
  );
}

interface CatalogFooterMobileProps {
  partnerID: string;
  messageableID: string;
  showLanguageSelector?: boolean;
  hubspotForm?: React.ReactNode;
  localeOptions?: LocaleOption[];
}

export function CatalogFooterMobile(props: CatalogFooterMobileProps) {
  const {
    messageableID,
    showLanguageSelector,
    hubspotForm,
    partnerID,
    localeOptions,
  } = props;
  const { locale, onChangeLocale } = useI18n();
  return (
    <Hidden md>
      {showLanguageSelector && localeOptions && (
        <Container center>
          <Container width={130}>
            <LocalePicker
              localeOptions={localeOptions}
              locale={locale}
              onChangeLocale={onChangeLocale}
            />
          </Container>
          <Spacer size={24} />
        </Container>
      )}
      <TalkWithUsPrompt
        partnerID={partnerID}
        hubspotForm={hubspotForm}
        messageableID={messageableID}
        messageableType={OfferingMessageType.PartnerCatalog}
      />
      <Spacer size={140} />
    </Hidden>
  );
}
